const companyStatusOpitons = [
  { value: "active", label: "Aktywna" },
  { value: "withdrawn", label: "Wycofana" },
  { value: "hidden", label: "Ukryta" },
];

export default companyStatusOpitons;
